// extracted by mini-css-extract-plugin
module.exports = {"packingItem":"jMdH5","packingItem-overlay":"Q8pVT","packingItem-name":"RkCd1","packingItem-price":"reP9z","packingItem-price-content":"c7WWy"};